import { useContext, useEffect } from 'react';
import { MembershipAppStateContext } from '../components/MembershipAppState/MembershipAppState';
import { LoadingIndicator } from '../components/LoadingIndicator';
import CookieHelper from '../utils/cookieHelper';
import { AppHeader } from '@ace-clublabs/shared-component-library';

export const LandingPage: React.FC = () => {
  const { loadingInfo, setZipCouponCampaignCodeAndFlowType } = useContext(MembershipAppStateContext);
  const zipCodeFromCookie = CookieHelper.getZipcodeFromZipcodeCookie();
  const urlParams = new URLSearchParams(window.location.search);
  const campaignCodeFromCookie = CookieHelper.getCampaignCodeFromCookie();
  const zipCodeFromUrl: string | null = urlParams.get('zipcode') ?? null;
  const couponCode: string | null = urlParams.get('couponcode') ?? null;
  const retrieveToken: string | null = urlParams.get('retrievetoken') ?? null;
  const campaignCode: string | null =
    urlParams.get('campaigncode') ??
    urlParams.get('campaignCode') ??
    urlParams.get('campaign') ??
    campaignCodeFromCookie ??
    null;
  const zipParam = urlParams.get('zip') ?? null;
  const assignZipCodeCookie = zipParam && zipParam !== zipCodeFromCookie;
  const flowType: string | null = urlParams.get('flow') ? (urlParams.get('flow')?.toUpperCase() ?? null) : null;
  const employeeId: string | null = urlParams.get('empid') ?? null;

  const addZipRouter = () => {
    const zipRouterScript = document.createElement('script');
    zipRouterScript.src = 'https://app.ace.aaa.com/zip-router/ace-zip-router-1.0.3.js';
    zipRouterScript.type = 'text/javascript';
    zipRouterScript.id = 'zip-router-modal-script';
    document.body.appendChild(zipRouterScript);
  };

  useEffect(() => {
    const zipCode = zipCodeFromUrl || zipCodeFromCookie;

    const s_ecid = CookieHelper.getCookie('s_ecid');
    const s_ecidSplit = s_ecid ? decodeURIComponent(s_ecid).split('|') : [];
    const ecid: string | null = s_ecidSplit && s_ecidSplit.length > 1 ? s_ecidSplit[1] : null;

    const zipCodeRouterListener = () => {
      const updatedZipCodeFromCookie = CookieHelper.getZipcodeFromZipcodeCookie();
      setZipCouponCampaignCodeAndFlowType(
        updatedZipCodeFromCookie,
        couponCode,
        campaignCode,
        flowType,
        window.location.search,
        employeeId,
        ecid,
        retrieveToken
      );
    };

    if (!zipCode || assignZipCodeCookie) {
      document.addEventListener('zipRouteUpdate', zipCodeRouterListener);
      document.addEventListener('zipCodeUpdatedEvent', zipCodeRouterListener);

      addZipRouter();
      return () => {
        document.removeEventListener('zipRouteUpdate', zipCodeRouterListener);
        document.removeEventListener('zipCodeUpdatedEvent', zipCodeRouterListener);
      };
    }

    setZipCouponCampaignCodeAndFlowType(
      zipCode,
      couponCode,
      campaignCode,
      flowType,
      window.location.search,
      employeeId,
      ecid,
      retrieveToken
    );
  }, []);

  const currentStep = loadingInfo.loadingDetails.length;
  return loadingInfo.isLoading ? (
    <>
      <AppHeader sx={{ padding: 0 }} />
      <LoadingIndicator loadingInfo={loadingInfo} maxSteps={2} currentStep={currentStep} displaySteps={1} />
    </>
  ) : (
    <>
      <AppHeader sx={{ padding: 0 }} />
    </>
  );
};
